import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_find_order_classService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { order_class: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Name?: string, OrderClassTypeId?: number, OrderTypeId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_class)) {
      missingRequiredInParams.push('\'order_class\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      order_class: string    }) {
        if(isNil(inParams.order_class)) {
          return true; 
        }
      return false;
    }
}
